import {
  animate,
  state,
  style,
  transition,
  trigger
} from "@angular/animations";

export function routerTransition() {
  return slideToTop();
}

export function slideToRight() {
  return trigger("routerTransition", [
    state("void", style({})),
    state("*", style({})),
    transition(":enter", [
      style({ transform: "translateX(-100%)" }),
      animate("0.5s ease-in-out", style({ transform: "translateX(0%)" }))
    ]),
    transition(":leave", [
      style({ transform: "translateX(0%)" }),
      animate("0.5s ease-in-out", style({ transform: "translateX(100%)" }))
    ])
  ]);
}

export function slideToLeft() {
  return trigger("routerTransition", [
    state("void", style({})),
    state("*", style({})),
    transition(":enter", [
      style({ transform: "translateX(100%)" }),
      animate("0.5s ease-in-out", style({ transform: "translateX(0%)" }))
    ]),
    transition(":leave", [
      style({ transform: "translateX(0%)" }),
      animate("0.5s ease-in-out", style({ transform: "translateX(-100%)" }))
    ])
  ]);
}

export function slideToBottom() {
  return trigger("routerTransition", [
    state("void", style({})),
    state("*", style({})),
    transition(":enter", [
      style({ transform: "translateY(-100%)" }),
      animate("0.5s ease-in-out", style({ transform: "translateY(0%)" }))
    ]),
    transition(":leave", [
      style({ transform: "translateY(0%)" }),
      animate("0.5s ease-in-out", style({ transform: "translateY(100%)" }))
    ])
  ]);
}

export function slideToTop() {
  return trigger("routerTransition", [
    state("void", style({})),
    state("*", style({})),
    transition(":enter", [
      style({ transform: "translateY(100%)" }),
      animate("0.5s ease-in-out", style({ transform: "translateY(0%)" }))
    ]),
    transition(":leave", [
      style({ transform: "translateY(0%)" }),
      animate("0.5s ease-in-out", style({ transform: "translateY(-100%)" }))
    ])
  ]);
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/iPOSERP/src/app/shared/animations/router.animations.ts